import { ScopeOfWorkV2FormService } from "@roc/feature-sow-shared/services";

const exportBaseUrl = '/nportal/rest/pub/scopeOfWork';

/**
 * Only the export is a public call: it turns the scope of work in the body into a spreadsheet and reads nothing stored.
 * Every other call of the revision page goes through its secure link session (SecureLinkScopeOfWorkRevisionService).
 */
const url = {
  EXPORT_SCOPE_OF_WORK_REVISION: `${exportBaseUrl}/exportScopeOfWorkExternalV2`,
};

export class ScopeOfWorkRevisionFormService extends ScopeOfWorkV2FormService {
  constructor() {
    super();
    this.url = url;
  }

  exportScopeOfWork(data: any) {
    return this.post(
      `${url.EXPORT_SCOPE_OF_WORK_REVISION}`,
      data,
      null,
      {
        responseType: 'arraybuffer',
      }
    );
  }
}
